import axios from '@/allotment/axios'

export default {
  list: () => axios.post('/role/find/list'), //获取角色列表
  save: data => axios.post('/role/save', data), //保存角色
  status: data => axios.post('/role/update/status', data), //删除角色
  menus: roleId => axios.get('/role/get/menus', { params: { roleId } }), //获取角色菜单
  perm: (roleId, menuIds) => axios.post('/role/perm', { roleId, menuIds }) //保存角色菜单
}